import { Nullable } from '@dxb-web-ui-framework/common/types';
import { Metadata } from './types';
class ConsolidatedTransactionDetails {
  creationDate: string;
  valueDate: string;
  orderId: number;
  status: string;
  type: string;
  details: string | null;
  amount: number;
  lastMovementDate: string;
  hasDocuments: boolean;
  globalOrderId: string;
  transactionId: number;
  mandateId: number;
  fromAccount: string;
  toAccount: string;
  accountCurrency: string;
  exchangeCurrency: string;
  exchangeRate: number;
  charges: string;
  country: string | null;
  beneficiaryCountry: string | null;
  beneficiaryCity: string | null;
  beneficiaryAddress: string | null;
  beneficiaryFullName: string | null;
  bankName: string;
  bankBic: string;
  sortCode: string | null;
  cor: string | null;
  bicBankCode: string | null;
  inn: string | null;
  kpp: string | null;
  vo: string | null;
  bop: string | null;
  hasRateRequest: string;
  dealRefNo: string | null;
  dealUsrCode: string | null;
  specialRate: number;
  trxRateGiven: number;
  alias: string | null;
  accountProductDescription: string | null;
  voDescription: string | null;
  customerId: number;
  fromAccountIban: string;
  totalCharges: number;
  trxCollectedAmount: number;
  trxCommissionAmount: number;
  trxExpensesAmount: number;
  trxOmniId: number;
  trxSettlementAmount: number;
  fromCurrencyId: number;
  toCurrencyId: number;
  exchangeRateApproximate: boolean;
  metadata: Nullable<Metadata>;
  orderProcessType: string;
  processedStatus: string;
  processingStatus: string;
  rateCurrencyISO: string;
  internalDestinationCurrencyId: number;
  internalDestinationCurrencyShortDescr: string;
  cancellationReason: string | null;
  p2pType: string | null;
  p2pValue: string | null;
  lastModifyCustomerId?: number | null;

  constructor(
    creationDate: string,
    valueDate: string,
    orderId: number,
    status: string,
    type: string,
    details: string | null,
    amount: number,
    lastMovementDate: string,
    hasDocuments: boolean,
    globalOrderId: string,
    transactionId: number,
    mandateId: number,
    fromAccount: string,
    toAccount: string,
    accountCurrency: string,
    exchangeCurrency: string,
    exchangeRate: number,
    charges: string,
    country: string | null,
    beneficiaryCountry: string | null,
    beneficiaryCity: string | null,
    beneficiaryAddress: string | null,
    beneficiaryFullName: string | null,
    bankName: string,
    bankBic: string,
    sortCode: string | null,
    cor: string | null,
    bicBankCode: string | null,
    inn: string | null,
    kpp: string | null,
    vo: string | null,
    bop: string | null,
    hasRateRequest: string,
    dealRefNo: string | null,
    dealUsrCode: string | null,
    specialRate: number,
    trxRateGiven: number,
    alias: string | null,
    accountProductDescription: string | null,
    voDescription: string | null,
    customerId: number,
    fromAccountIban: string,
    totalCharges: number,
    trxCollectedAmount: number,
    trxCommissionAmount: number,
    trxExpensesAmount: number,
    trxOmniId: number,
    trxSettlementAmount: number,
    fromCurrencyId: number,
    toCurrencyId: number,
    exchangeRateApproximate: boolean,
    metadata: Nullable<Metadata>,
    orderProcessType: string,
    processedStatus: string,
    processingStatus: string,
    rateCurrencyISO: string,
    internalDestinationCurrencyId: number,
    internalDestinationCurrencyShortDescr: string,
    cancellationReason: string | null,
    p2pType: string | null,
    p2pValue: string | null,
    lastModifyCustomerId?: number | null,
  ) {
    this.creationDate = creationDate;
    this.valueDate = valueDate;
    this.orderId = orderId;
    this.status = status;
    this.type = type;
    this.details = details && details?.length > 0 ? details : null;
    this.amount = amount;
    this.lastMovementDate = lastMovementDate;
    this.hasDocuments = hasDocuments;
    this.globalOrderId = globalOrderId;
    this.transactionId = transactionId;
    this.mandateId = mandateId;
    this.fromAccount = fromAccount;
    this.toAccount = toAccount;
    this.accountCurrency = accountCurrency;
    this.exchangeCurrency = exchangeCurrency;
    this.exchangeRate = exchangeRate;
    this.charges = charges;
    this.country = country && country?.length > 0 ? country : null;
    this.beneficiaryCountry = beneficiaryCountry;
    this.beneficiaryCity = beneficiaryCity;
    this.beneficiaryAddress = beneficiaryAddress && beneficiaryAddress?.length > 0 ? beneficiaryAddress : null;
    this.beneficiaryFullName = beneficiaryFullName && beneficiaryFullName?.length > 0 ? beneficiaryFullName : null;
    this.bankName = bankName;
    this.bankBic = bankBic;
    this.sortCode = sortCode && sortCode?.length > 0 ? sortCode : null;
    this.cor = cor && cor?.length > 0 ? cor : null;
    this.bicBankCode = bicBankCode && bicBankCode?.length > 0 ? bicBankCode : null;
    this.inn = inn && inn?.length > 0 ? inn : null;
    this.kpp = kpp && kpp?.length > 0 ? kpp : null;
    this.vo = vo && vo?.length > 0 ? vo : null;
    this.bop = bop && bop?.length > 0 ? bop : null;
    this.hasRateRequest = hasRateRequest;
    this.dealRefNo = dealRefNo && dealRefNo?.length > 0 ? dealRefNo : null;
    this.dealUsrCode = dealUsrCode && dealUsrCode?.length > 0 ? dealUsrCode : null;
    this.specialRate = specialRate;
    this.trxRateGiven = trxRateGiven;
    this.alias = alias;
    this.accountProductDescription =
      accountProductDescription && accountProductDescription?.length > 0 ? accountProductDescription : null;
    this.voDescription = voDescription;
    this.customerId = customerId;
    this.fromAccountIban = fromAccountIban;
    this.totalCharges = totalCharges;
    this.trxCollectedAmount = trxCollectedAmount;
    this.trxCommissionAmount = trxCommissionAmount;
    this.trxExpensesAmount = trxExpensesAmount;
    this.trxOmniId = trxOmniId;
    this.trxSettlementAmount = trxSettlementAmount;
    this.fromCurrencyId = fromCurrencyId;
    this.toCurrencyId = toCurrencyId;
    this.exchangeRateApproximate = exchangeRateApproximate;
    this.metadata = metadata;
    this.orderProcessType = orderProcessType;
    this.processedStatus = processedStatus;
    this.processingStatus = processingStatus;
    this.rateCurrencyISO = rateCurrencyISO;
    this.internalDestinationCurrencyId = internalDestinationCurrencyId;
    this.internalDestinationCurrencyShortDescr = internalDestinationCurrencyShortDescr;
    this.lastModifyCustomerId = lastModifyCustomerId;
    this.cancellationReason = cancellationReason && cancellationReason?.length > 0 ? cancellationReason : null;
    this.p2pType = p2pType;
    this.p2pValue = p2pValue;
  }
}

export { ConsolidatedTransactionDetails };
